import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DisabledField from './DisabledField'
import EnabledField from './EnabledField'
import fetchApi from '../../../../services/fetchApi'
import { renderAlert } from '../../../../services/render-alert'
import css from '../patientCard.css'

class ContactField extends Component {
  static propTypes = {
    id: PropTypes.string,
    loadPatientWithRelations: PropTypes.func,
    fieldToUpdate: PropTypes.string.isRequired,
    patient: PropTypes.object.isRequired,
    requiresTier2: PropTypes.bool,
    hasRemindersTier2: PropTypes.bool,
  }

  constructor(props) {
    super(props)
    this.state = {
      editingContact: false,
      fieldValue: this.props.patient[this.props.fieldToUpdate] || '',
    }
  }

  toggleEditContactInfo = () => {
    const { editingContact: oldEdit } = this.state
    this.setState({ editingContact: !oldEdit })
  }

  handleChange = (e) => {
    this.setState({ fieldValue: e.target.value })
  }

  handleSave = (e) => {
    e.preventDefault()
    const { fieldValue } = this.state
    const { fieldToUpdate, patient, id, loadPatientWithRelations } = this.props
    const updatedPatientInfo = {}
    updatedPatientInfo[fieldToUpdate] = fieldValue
    const requestBody = { body: JSON.stringify(updatedPatientInfo) }
    fetchApi(`/patients/${patient.id}`, 'PATCH', requestBody)
      .then((res) => {
        if (res.error) {
          renderAlert(res.error, 'error')
        } else {
          if (loadPatientWithRelations) {
            loadPatientWithRelations(id, {
              with_reminders_contact_information: true,
            })
          }
          this.setState(
            { fieldValue: res[fieldToUpdate] },
            this.toggleEditContactInfo,
          )
        }
      })
      .catch((err) => {
        console.error(err)
      })
  }

  render() {
    const { fieldToUpdate, requiresTier2, hasRemindersTier2 } = this.props
    const { editingContact, fieldValue } = this.state
    const contactInfoLabel = fieldToUpdate.split('_').join(' ')
    return (
      <div className={css.contactFieldContainer}>
        {requiresTier2 && !hasRemindersTier2 ? (
          <DisabledField contactInfoLabel={contactInfoLabel} />
        ) : (
          <EnabledField
            editingContact={editingContact}
            contactInfo={fieldValue}
            handleChange={this.handleChange}
            handleSave={this.handleSave}
            contactInfoLabel={contactInfoLabel}
            editContact={this.toggleEditContactInfo}
          />
        )}
      </div>
    )
  }
}

export default ContactField



// WEBPACK FOOTER //
// ./src/components/PatientPage/PatientCard/ContactField/index.js